import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import HomePage from '../pages/HomePage/Homepage';
import SponsorsPage from '../pages/SponsorsPage/SponsorsPage';
import InfoPage from '../pages/InfoPage/InfoPage'
import SpeakersPage from '../pages/SpeakersPage/SpeakersPage';
import SpeakersPages from '../pages/SpeakersPage/SpeakersPages';
import LocationPage from '../pages/LocationPage/LocationPage';
import AgendaPage from '../pages/AgendaPage/AgendaPage';
import ResearchPage from '../pages/ResearchPage/ResearchPage';
import LivingLabsPage from '../pages/LivingLabsPage/LivingLabsPage';
import DigitalTwinPage from '../pages/DigitalTwinPage/DigitalTwinPage';

/** Reset window scroll on client-side navigation (Router does not do this by default). */
function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

/** Sends users to the static multi-page workshop under public/IEEE_IV_2026_DT/ */
function IeeeIvDtivRedirect() {
  useEffect(() => {
    window.location.replace(
      `${window.location.origin}/IEEE_IV_2026_DT/index.html${window.location.search}${window.location.hash}`
    );
  }, []);
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>Redirecting to DT-IV workshop…</p>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/speakers" element={<SpeakersPage />} />
          {/* <Route path="/info" element={<InfoPage />} /> */}
          <Route path="/organizers" element={<SponsorsPage />} />
          <Route path="/location" element={<LocationPage />} />
          <Route path="/agenda" element={<AgendaPage />} />
          <Route path="/research" element={<ResearchPage />} />
          <Route path="/living-labs" element={<LivingLabsPage />} />
          <Route path="/digital-twin" element={<DigitalTwinPage />} />
          <Route path="/IEEE_IV_2026_DT" element={<IeeeIvDtivRedirect />} />
          <Route path="/IEEE_IV_2026_DT/" element={<IeeeIvDtivRedirect />} />
        </Routes>
    </Router>
    </div>
  );
}

export default App;
